import API from "../api.js";

const fetchData = async ({ setData }) => {
  let dataObj = {
    stats: {},
    coins: [],
  };

  await API.get("/market/list/1/100")
    .then((res) => {
      dataObj = {
        ...dataObj,
        coins: res.data,
      };
    })
    .catch((err) => console.error(err));

  await API.get("/market/stats")
    .then((res) => {
      dataObj = {
        ...dataObj,
        stats: res.data,
      };
    })
    .catch((err) => console.error(err));

  await setData(dataObj);
};

export default fetchData;
